<ion-header class=ion-no-border>
    <ion-toolbar mode="ios">
        <ion-title>{{'Reassign' | translation}}/{{'Close' | translation}}</ion-title>
        <ion-buttons slot="end">
            <ion-button fill="clear" (click)="dismiss()">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <ion-list>
        <ion-item>
            <ion-label>{{'Close' | translation}}</ion-label>
            <ion-button slot="end" (click)="closeConversation()">
                <ion-icon slot="icon-only" name="return-up-back"></ion-icon>
            </ion-button>
        </ion-item>
    </ion-list>
    <ion-list>
        <ion-list-header>{{'ReassignTheContact' | translation}}</ion-list-header>

        <ion-item>
            <ion-label>{{'MyLeader' | translation}}</ion-label>
            <ion-button slot="end" (click)="addnote('note_field_leader')">
                <ion-icon slot="icon-only" name="return-up-back"></ion-icon>
            </ion-button>
<!--            <ion-button slot="end" (click)="reassign('leader')">-->
<!--                <ion-icon slot="icon-only" name="return-up-back"></ion-icon>-->
<!--            </ion-button>-->
        </ion-item>
        <ng-container *ngIf="note_field_leader">
            <ion-item>
                <ion-input placeholder="{{ 'Enter Reassign Leader Note' | translation }}" [(ngModel)]="leader_note" style="text-transform: none;">
                </ion-input>
                <ion-button slot="end" size="sm" color="secondary" (click)="reassign('leader')">{{ 'Done' | translation}}</ion-button>
            </ion-item>
        </ng-container>

<!--        <ion-item>-->
<!--            <ion-label>{{'Pool' | translation}}</ion-label>-->
<!--            <ion-button slot="end" (click)="reassign('pool')">-->
<!--                <ion-icon slot="icon-only" name="return-up-back"></ion-icon>-->
<!--            </ion-button>-->
<!--        </ion-item>-->
        <ion-item>
            <ion-label>{{'PreviousOM' | translation}}</ion-label>
            <ion-button slot="end" (click)="addnote('note_field_previousOM')">
                <ion-icon slot="icon-only" name="return-up-back"></ion-icon>
            </ion-button>
        </ion-item>
        <ng-container *ngIf="note_field_previousOM">
            <ion-item>
                <ion-input placeholder="{{'EnterPreviousOMNote'| translation}}" [(ngModel)]="previousOM_note" style="text-transform: none;">
                </ion-input>
                <ion-button slot="end" size="sm" color="secondary" (click)="reassign('previous')">{{ 'Done' | translation}}</ion-button>
            </ion-item>
        </ng-container>
        <ion-item>
            <ion-label>{{'Abusive' | translation}}</ion-label>
            <ion-button slot="end" (click)="addnote('note_field')">
                <ion-icon slot="icon-only" name="return-up-back"></ion-icon>
            </ion-button>
        </ion-item>
        <ng-container *ngIf="note_field">
            <ion-item>
                <ion-input placeholder="{{ 'Enter Reassign Abusive Note' | translation }}" [(ngModel)]="abusive_note" style="text-transform: none;">
                </ion-input>
                <ion-button slot="end" size="sm" color="secondary" (click)="reassign('abusive')">{{ 'Done' | translation}}</ion-button>
            </ion-item>
        </ng-container>
        <!-- reverted test change -->
        <ion-item>
            <ion-label>{{'OtherLanguages' | translation}}</ion-label>
            <ion-button slot="end" (click)="addnote('note_field_language')">
                <ion-icon slot="icon-only" name="return-up-back"></ion-icon>
            </ion-button>
        </ion-item>

            <ng-container *ngIf="note_field_language">

                <ion-item>
                    <ion-input placeholder="{{ 'Enter Reassign Language Note' | translation }}" [(ngModel)]="language_note" style="text-transform: none;"></ion-input>
                </ion-item>

                <ion-item>
            <ion-select label="{{ 'Select' | translation }}" value="" okText="{{'Reassign' | translation}}" cancelText="{{'Cancel' | translation}}" (ionChange)="reassignSelect('language', $event)">
                <ng-container  *ngFor="let lang of languages">
                    <ion-select-option *ngIf="lang.id!=languageid" value="{{ lang.id }}">{{ lang.language_name | translation }}
                    </ion-select-option>
                </ng-container>
                <ion-select-option value="-1">{{ 'Other' | translation }}</ion-select-option>
            </ion-select>
                </ion-item>
            </ng-container>
        <!-- <ion-item>
      <ion-label>Specialty Community</ion-label>
      <ion-select value="" ok-text="Save" cancel-text="Dismiss" (ionChange)="reassignSelect('community', $event)">
        <ion-select-option *ngFor="let comm of communities" value="{{ comm.uuid }}">{{ comm.name }}</ion-select-option>
      </ion-select>
    </ion-item> -->
        <ion-item>
            <ion-label>{{'Category' | translation}}</ion-label>
            <ion-button slot="end" (click)="addnote('note_field_category')">
                <ion-icon slot="icon-only" name="return-up-back"></ion-icon>
            </ion-button>
        </ion-item>

        <ng-container *ngIf="note_field_category">

            <ion-item>
                <ion-input placeholder="{{ 'Enter Reassign Category Note' | translation }}" [(ngModel)]="category_note" style="text-transform: none;"></ion-input>
            </ion-item>

            <ion-item>
            <ion-select label="{{ 'Select' | translation }}" value="" okText="{{'Reassign' | translation}}" cancelText="{{'Cancel' | translation}}" (ionChange)="reassignSelect('category', $event)">
                <ng-container  *ngFor="let cat of categories">
                    <ion-select-option *ngIf="cat.uuid!=categoryuuid && cat.uuid!=category_uuid && cat.language_id==language_id" value="{{ cat.uuid }}">{{ cat.title }}</ion-select-option>
                </ng-container>
            </ion-select>
        </ion-item>
        </ng-container>
    </ion-list>
</ion-content>
